import { Injectable } from '@angular/core';
import { ManageCartsResponse, CustomSavedCartsServiceData, ManageCartsInfo, LegalEntitiesFilterRepsonse } from '../state/cart-details.state';
import { LegalEntity } from '../state/cart-details.state';
import { FilterDataForTable, ColumnName, ColumnLabel } from '../../models/cart-data.model';
import { Column, ColumnType } from '../../../../SGRE-shared/models/tableConfiguration';
import { CustomCart } from '../../../cart/models/custom-cart.model';
import { StorageService } from '../../../../SGRE-shared/services/storage.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { take } from 'rxjs';

@Injectable()
export class ManageCartsEffectService {

  constructor(
    private storageService: StorageService,
    private globalService: GlobalService,
  ) { }

  processCartData(data: ManageCartsResponse, leFilterData?: LegalEntitiesFilterRepsonse): ManageCartsInfo {
    let filters: string[];
    this.globalService.getSaveCartsFilter()
      .pipe(take(1))
      .subscribe((data) => filters = data);
    const legalEntities = leFilterData?.legalEntities || this.storageService?.userLegalEntities || [];

    const filterListData: FilterDataForTable[] = legalEntities?.map(option => ({
      legalEntity: option?.name,
      uid: option?.uid,
      selected: filters?.includes(option?.uid)
    })) || [];

    // Map saved carts data
    const savedCartsData: ManageCartsResponse = {
      carts: data?.carts?.map(this.mapManageCartsData.bind(this)) || [],
      currentPage: data?.currentPage,
      numberOfPages: data?.numberOfPages,
      pageSize: data?.pageSize,
      totalNumber: data?.totalNumber
    };

    // Return the result with table configuration
    const result = {
      manageCartsData: savedCartsData,
      columns: this.createTableConfiguration(filterListData)
    } as ManageCartsInfo;
    return result;
  }

  mapManageCartsData(savedCartData: CustomCart, index: number): CustomSavedCartsServiceData {
    const cartData: CustomSavedCartsServiceData = { ...savedCartData };
    const leDataFromResponse = savedCartData?.legalEntity as LegalEntity;

    cartData.id = savedCartData?.code ? Number(savedCartData.code) : null;
    cartData.index = index;
    cartData.cartName = savedCartData?.name ?? "-";
    cartData.legalEntity = leDataFromResponse?.name;
    cartData.legalEntityDetails = leDataFromResponse;
    cartData.items = savedCartData?.totalItems ?? 0;
    cartData.price = savedCartData?.totalPrice?.value ?? 0;
    cartData.currency = savedCartData?.totalPrice?.currencyIso ?? '-';
    cartData.selected = this.storageService.defaultLegalEntity?.name === leDataFromResponse?.name && savedCartData?.isActiveCart;

    return cartData;
  }

  createTableConfiguration(legalEntityFilterList: FilterDataForTable[]): Column[] {
    const columnData: Column[] = [
      {
        label: ColumnLabel.CartName,
        name: ColumnName.CartName,
        type: ColumnType.text,
        sort: true,
        style: 'large',
      },
      {
        label: ColumnLabel.LegalEntity,
        name: ColumnName.LegalEntity,
        type: ColumnType.text,
        filter: true,
        filterOptions: legalEntityFilterList,
        style: 'large',
      },
      {
        label: ColumnLabel.Items,
        name: ColumnName.Items,
        type: ColumnType.number,
        sort: true,
      },
      {
        label: ColumnLabel.Price,
        name: ColumnName.Price,
        type: ColumnType.price,
        sort: true,
      },
      {
        label: ColumnLabel.DuplicateCart,
        name: ColumnName.Duplicate,
        type: ColumnType.duplicate,
      },
      {
        label: ColumnLabel.DeleteCart,
        name: ColumnName.Delete,
        type: ColumnType.delete,
      },
      {
        label: ColumnLabel.SelectCart,
        name: ColumnName.Select,
        type: ColumnType.radio,
      },
    ];
    const columns: Column[] = columnData.map((item) => new Column(item));
    return columns;
  }
}
